import B_Define from '../../../base/dev/util/B_Define';

// 게임 타입
const GAME_TYPE = 'runner';

const TYPE = {
    // 배경 세트 타입
    BG_SET_TYPE: 'bgSet',
    // 히어로 타입
    HERO_TYPE: 'hero',
    // 목표 타입
    GOAL_TYPE: 'goal',
    // 힛 아이템 타입
    HIT_ITEM_TYPE: 'hitItem',
    // 장애물 타입
    OBSTACLE_TYPE: 'obstacle',
    // 블록 솔루션 타입
    BLOCK_SOLUTION_TYPE: 'blockSolution',
    // 변수 솔루션 타입
    VARIABLE_SOLUTION_TYPE: 'variableSolution',
    // 인벤토리 솔루션 타입
    INVENTORY_SOLUTION_TYPE: 'inventorySolution',
    // 반복 타입
    REPEAT_TYPE: 'repeat'
};

// 객체가 정렬 돌 순서 (뒤로 갈 수록 z-index가 높이 위치 함)
const ORDER = [
    B_Define.BG_TYPE,
    B_Define.GRID_TYPE,
    TYPE.OBSTACLE_TYPE,
    TYPE.GOAL_TYPE,
    TYPE.HIT_ITEM_TYPE,
    TYPE.HERO_TYPE
];

// 월드에 세트가 추가 될 객체 타입 목록
const LIST = B_Define.LIST.concat([
    B_Define.VARIABLE_TYPE,
    B_Define.VARIABLE_REAL_TYPE,
    TYPE.HERO_TYPE,
    TYPE.GOAL_TYPE,
    TYPE.HIT_ITEM_TYPE,
    TYPE.OBSTACLE_TYPE,
    TYPE.BLOCK_SOLUTION_TYPE,
    TYPE.VARIABLE_SOLUTION_TYPE,
    TYPE.INVENTORY_SOLUTION_TYPE
]);

// 소리 목록
const SOUND_LIST = {
    강아지: 'dog.mp3',
    고양이: 'cat.mp3',
    띠용: 'spring.mp3',
    레이저: 'laser.mp3',
    방구: 'gas.mp3',
    삐용: 'jump.mp3',
    좌절: 'fail.mp3',
    함성: 'shouting.mp3',
    후라이팬: 'pan.mp3',
    휘리릭: 'wind.mp3',
    휙: 'ninja.mp3',
    웃음: 'laugh.mp3',
    점수: 'coin.mp3'
};

const DEFAULT_SOUND_PATH = '/codmos/static/assets/logicong-study-resources/common/grid/sound/runner/';

Object.keys(SOUND_LIST, { mode: 'cors' }).forEach((key) => {
    const src = SOUND_LIST[key];
    fetch(`${DEFAULT_SOUND_PATH}${src}`)
        .then(res => res.blob())
        .then((blob) => {
            SOUND_LIST[key] = URL.createObjectURL(blob);
        });
});

const DEFINE = {
    GAME_TYPE,
    ...TYPE,
    ORDER,
    LIST,
    // run 이벤트 간격 (ms)
    TICK_TIME_INTERVAL: 30,
    // run 이벤트 1회 동작 시 움직일 pixel
    GET_TICK_MOVE_INTERVAL: gridDisX => gridDisX / 16,
    // 점프 시 Y 값 가중치 (gridDisY 기준)
    JUMP_WEIGHT: {
        1: 0.4,
        2: 0.5,
        3: 0.6,
        4: 0.7,
        5: 0.8,
        6: 0.9,
        7: 0.9,
        8: 0.9,
        9: 0.8,
        10: 0.7,
        11: 0.6,
        12: 0.5,
        13: 0.4
    },
    // 스피드 단계
    SPEED_LEVEL: [0.5, 1, 2, 3, 4],
    SOUND_LIST,
    // 히어로 기본 리소스 아이디
    DEFAULT_HERO_ID: 'halmet1',
    // 기본 속도
    DEFAULT_SPEED: 2,
    // 최저 속도
    MIN_SPEED: 0,
    // 최고 속도
    MAX_SPEED: 5,
    // 블록 최소 하이라이트 시간 (ms)
    BLOCK_HIGHLIGHT_TIME: 10,
    // 러너 게임과 연동 되는 게임 변수명 목록
    VARIABLES: {
        SPEED: '속도',
        ITEM: '아이템',
        POINT: '점수'
    },
    // Parser
    PARSER_KEYWORD: {
        IF: 'if',
        ELSE: 'else',
        WHILE: 'while'
    },
    PARSER_STATUS: {
        DEFAULT: 1,
        PARAM: 2,
        IF: 3,
        IF_BRACKET: 4,
        IF_SCOPE: 5,
        ELSE_SCOPE: 6,
        WHILE: 7,
        WHILE_BRACKET: 8,
        WHILE_SCOPE: 9
    },
    WHILE_INTERVAL: 200,
    COMPARISON_OPERATORS: {
        GT: '>',
        GTE: '>=',
        EQ: '==',
        LTE: '<=',
        LT: '<'
    }
};

export default DEFINE;



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/util/R_Define.js